import React from "react";

const CardPaymentView = () => {
  return <div></div>;
};

export default CardPaymentView;
